<template>
    <div class="leftTree">
        <div class="logo">
            <img src="../../assets/images/logo.png" alt="">
            <p :style="{display:(isCollapse?'none':'block')}">事件管理平台</p>
        </div>
        <el-menu :default-active="openIndex" @select="handleOpen" :collapse="isCollapse" class="el-menu-vertical-demo"
                 :unique-opened="uniqueOpened" :default-openeds="defaultOpeneds">
            <div v-for="(item,i) in leftData" :key="i.toString()">
                <el-sub-menu :index="item.index" v-if="item.children">
                    <template #title>
                        <i class="leftIcon" :class="item.icon"></i>
                        <!--<img class="leftIcon" :src="item.icon" alt="">-->
                        <span>{{item.submenu}}</span>
                    </template>
                    <el-menu-item v-for="(item1,j) in item.children" :index="item1.linkTo+''">
                        <span>{{item1.menuItem}}</span>
                    </el-menu-item>
                </el-sub-menu>
                <el-menu-item v-else class="l_el-menu-item" :index="item.linkTo+''">
                    <!--<img class="leftIcon" :src="item.icon" alt="">-->
                    <!--<img class="leftIcon is-active" :src="item.icon_a" alt="">-->
                    <i class="leftIcon" :class="item.icon"></i>
                    <template #title>{{item.submenu}}</template>
                </el-menu-item>
            </div>
        </el-menu>
        <div class="leftTree_bottom" :class="{unfold:isCollapse}">
            <div class="leftTree_unfold" @click="fold">
                <img src="../../assets/images/unfold_line.png" alt="">
            </div>
            <div class="leftTree_setup">
                <img src="../../assets/images/ico_gl.png" alt="">
                <span>设置</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {ref, reactive, getCurrentInstance, onMounted, watch} from 'vue'
    import {useStore} from 'vuex'

    export default {
        name: "leftTree",
        setup(props, context) {
            const {proxy} = getCurrentInstance();
            const store = useStore();
            const openIndex = ref("");
            const defaultOpeneds = ref(["sjgl"])
            let leftData = reactive([
                {
                    icon: "icon-ico_sy",
                    submenu: "首页",
                    linkTo: "/Home",
                    name: 'Home',
                }, {
                    icon: "icon-ico_sjgl",
                    submenu: "事件管理",
                    index: "sjgl",
                    children: [
                        {
                            menuItem: "网格事件",
                            linkTo: "/Jsjb",
                            name: 'Jsjb'
                        }
                    ]
                },
                // {
                //     icon: "icon-ztfx",
                //     submenu: "总体分析",
                //     linkTo: "/TotallAnalysis",
                //     name: 'TotallAnalysis'
                // },
                // {
                //     icon: "icon-cbdw",
                //     submenu: "承办单位",
                //     linkTo: "/CheckCondition",
                //     name: 'CheckCondition'
                // },
                {
                    icon: "icon-ico_sjgl",
                    submenu: "统计分析",
                    index: "tjfx",
                    children: [
                        {
                            menuItem: "网格概览",
                            linkTo: "/GridOverview",
                            name: 'GridOverview'
                        },
                        {
                            menuItem: "承办分析",
                            linkTo: "/UndertakingAnalysis",
                            name: 'UndertakingAnalysis'
                        }
                    ]
                },
                {
                    icon: "icon-ico_sjgl",
                    submenu: "绩效考核",
                    index: "jxkh",
                    children: [
                        {
                            menuItem: "承办单位考核",
                            linkTo: "/Cbdwkh",
                            name: 'Cbdwkh'

                        },
                        {
                            menuItem: "网格员考核",
                            linkTo: "/Wgykh",
                            name: 'Wgykh'
                        }
                    ]
                },
                {
                    icon: "icon-ico_sjgl",
                    submenu: "工具箱",
                    index: "gjx",
                    children: [
                        {
                            menuItem: "通讯录",
                            linkTo: "/AddressBook",
                            name: 'AddressBook'
                        },
                        {
                            menuItem: "文件下载",
                            linkTo: "/FileDownload",
                            name: 'FileDownload'
                        }
                    ]
                },
            ]);
            const isCollapse = ref(false);
            const fold = () => {
                isCollapse.value = !isCollapse.value
            }
            const handleOpen = (index) => {
                var obj = {
                    name: "",
                    label: "",
                    linkTo: "",
                    query: null,
                }

                for (var i = 0; i < leftData.length; i++) {
                    if (leftData[i].children) {
                        for (var j = 0; j < leftData[i].children.length; j++) {
                            if (leftData[i].children[j].linkTo == index) {
                                obj.name = leftData[i].children[j].name;
                                obj.label = leftData[i].children[j].menuItem;
                                obj.linkTo = leftData[i].children[j].linkTo;
                                store.commit('addLeftTreeToHeaderTab', obj);
                                // store.commit("headerActiveTabChange",leftData[i].children[j].submenu);
                                // context.emit('leftTreeJumpRouter', leftData[i].children[j].submenu)
                                return
                            }
                        }
                    } else {
                        if (leftData[i].linkTo == index) {
                            obj.name = leftData[i].name;
                            obj.label = leftData[i].submenu;
                            obj.linkTo = leftData[i].linkTo;
                            store.commit('addLeftTreeToHeaderTab', obj);
                            // store.commit("headerActiveTabChange",leftData[i].submenu);
                            // context.emit('leftTreeJumpRouter', leftData[i].submenu)
                            return
                        }
                    }
                }
            }
            let projectName = ref("事件管理平台")
            watch(() => store.state.addMapSignTree, (newVal) => {
                if (newVal) {
                    leftData.push({
                        icon: "icon-ico_yxdt",
                        submenu: "事件地图",
                        linkTo: "/RunMap",
                        name: 'RunMap'
                    })
                    // leftData.push({
                    //     icon: "icon-ico_qd",
                    //     submenu: "签到",
                    //     index: "qd",
                    //     children: [
                    //         {
                    //             menuItem: "考勤统计",
                    //             linkTo: "/StatisticalAnalysis",
                    //             name: 'StatisticalAnalysis'
                    //         }
                    //     ]
                    // })
                }else{
                    leftData=leftData.slice(0,5)
                }
            })

            onMounted(() => {
                // proxy.$axios.get("/jgfast/wgsj/sysName").then((res) => {
                //     projectName.value = res.data;
                // })
            })
            return {
                openIndex,
                leftData,
                isCollapse,
                fold,
                handleOpen,
                projectName,
                defaultOpeneds
            }
        }
    }
</script>

<style lang="less">

</style>
